/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Secrets_CleanInputs */

const en_rd_secrets_clean = /** @type {(inputs: Rd_Secrets_CleanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hardcoded keys in the files we scanned.`)
};

const id_rd_secrets_clean = /** @type {(inputs: Rd_Secrets_CleanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada kunci hardcoded di berkas yang kami pindai.`)
};

/**
* | output |
* | --- |
* | "No hardcoded keys in the files we scanned." |
*
* @param {Rd_Secrets_CleanInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_secrets_clean = /** @type {((inputs?: Rd_Secrets_CleanInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Secrets_CleanInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_secrets_clean(inputs)
	return en_rd_secrets_clean(inputs)
});